import React from "react";
import ImBg from "assets/images/im-daftarDesa.jpg";

export default function HeaderListDesa() {
  return (
    <>
      <div
        className={`flex flex-col relative justify-center min-h-screen px-5 font-bold text-center bg-no-repeat bg-cover md:px-0 md:text-6xl header-wrapper bg-inherit`}
        style={{
          backgroundImage: `url('${ImBg}')`,
          backgroundSize: "cover",
          backgroundPosition: "inherit",
          // backgroundPositionY: -10,
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
      >
        <div className="absolute inset-0 bg-gray-900 opacity-40"/>
        <div className="relative mt-20 text-center heading-wrapper">
          <h1 className="text-xl text-white lg:text-3xl">
            Semua desa ingin menjadi Geulanggang-Panah
          </h1>
        </div>
      </div>
    </>
  );
}
